<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog max-width="600" persistent v-model="$store.getters.actionLibraryModal">
            <v-card>
                <v-card-title class="primary">
                    <span class="headline white--text">Ενέργειες Παραγγελίας</span>
                    <v-spacer></v-spacer>
                    <v-icon @click="exitModal" color="white">close</v-icon>
                </v-card-title>
                <br/>
                <v-card-text>
                    <v-container class="pt-0 mt-0">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Ίδρυμα</v-list-item-title>
                                <v-list-item-subtitle>{{libraryObject.institutionName}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Τμήμα</v-list-item-title>
                                <v-list-item-subtitle class="text-wrap">{{libraryObject.academicName}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Βιβλιοθήκη</v-list-item-title>
                                <v-list-item-subtitle class="text-wrap">{{libraryObject.libraryName}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Κωδικός Βιβλίου</v-list-item-title>
                                <v-list-item-subtitle>{{libraryObject.bookId}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Βιβλίο</v-list-item-title>
                                <v-list-item-subtitle class="text-wrap">{{libraryObject.bookTitle}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Τεμάχια</v-list-item-title>
                                <v-list-item-subtitle>{{libraryObject.amount}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Κατάσταση</v-list-item-title>
                                <v-list-item-subtitle>{{status(libraryObject.status)}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Ημερομηνία</v-list-item-title>
                                <v-list-item-subtitle>{{returnTheDate(libraryObject.statusDate)}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-card-subtitle class="pb-0" v-if="doneButtonDisabled() && libraryObject.status == 'Pending'">
                            <p subtitle-2>Για την ολοκλήρωση της παραγελίας εισάγετε τον αριθμό PIN που θα σας δώσει η
                                Βιβλιοθήκη και πατήστε 'Ολοκλήρωση'</p>
                        </v-card-subtitle>
                        <v-row v-if="doneButtonDisabled() && libraryObject.status == 'Pending'">
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field label="Αριθμός PIN" v-model="pin"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">
                                <v-btn block @click="completeLIbraryOrder" class="white--text primary mt-3">Ολοκλήρωση
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-if="libraryObject.status == 'Completed'">
                            <v-col>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on"
                                               @click="printReceiptOrder"
                                               block class="white--text primary mt-3">Εκτύπωση
                                        </v-btn>
                                    </template>
                                    <span>Για την εκτύπωση της απόδειξης πατήστε 'Εκτύπωση Απόδειξης</span>
                                </v-tooltip>
                            </v-col>
                            <v-col>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on"
                                               @click="cancelButton"
                                               :disabled="!doneButtonDisabled()"
                                               block class="white--text primary mt-3">Ακύρωση Ολοκλήρωσης
                                        </v-btn>
                                    </template>
                                    <span>Για την ακύρωση της ολοκλήρωσης της παραγγελίας πατήστε 'Ακύρωση'</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import utils from '../../utilities'
    import request from '../../requests'

    export default {
        name: "ActionLibraryOrder",

        data: () => ({
            pin: '',
            utils,
        }),

        props: {
            libraryObject: Object
        },

        methods: {

            printReceiptOrder() {

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.printReceiptOrder(token, this.libraryObject.id,  this.printReceiptOrderCallBack)
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            printReceiptOrderCallBack(response) {

                this.$store.commit('setLoadingModal', false);
                const file = new Blob(
                    [response],
                    {type: 'application/pdf'});

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            },

            completeLIbraryOrder() {

                this.$store.commit('setActionLibraryModal', false);
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.completeLibraryOrder(token, this.libraryObject.id, this.pin,  this.completeLibraryOrderCallBack)
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            completeLibraryOrderCallBack(response) {

                this.updateDataTable(response);
            },

            cancelButton() {
                this.$store.commit('setActionLibraryModal', false);
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.cancelLibraryOrder(token, this.libraryObject.id, this.cancelLibraryOrderCallBack)
                } else {
                    this.$store.commit('setloginModal', true);
                }

            },

            cancelLibraryOrderCallBack(response) {

                this.updateDataTable(response);
            },

            updateDataTable(response){

                this.pin = '';
                var libraryOrder =  this.$store.getters.libraryOrder;
                this.$store.commit('setLibraryOrder', []);
                for (var i = 0; i < libraryOrder.length; i++) {
                    if (libraryOrder[i].id == response.id) {
                        libraryOrder[i].status = response.status;
                        libraryOrder[i].statusDate = response.statusDate;
                        this.$store.commit('setLibraryOrder', libraryOrder);
                        this.$store.commit('setLoadingModal', false);
                        return;
                    }
                }
            },
            
            status(status) {
              
                if (status == "Completed") {
                    return 'Ολοκληρώθηκε'
                }
                return 'Προετοιμασία για Αποστολή'
            },

            exitModal(){
                this.$store.commit('setActionLibraryModal', false);
                this.pin = '';
            },

            // disabled or enabled done button
            doneButtonDisabled() {
                var libraryOrderAllowedPeriod = this.$store.getters.homePageInformation.libraryOrderAllowedPeriod;
                var activeYear = this.$store.getters.activeYear;

                if (libraryOrderAllowedPeriod && this.libraryObject.year == activeYear) {
                    return true;
                }
                return false;

            },

            returnTheDate (year) {

                var date = new Date(year).toLocaleDateString();
                return date;
            },

        }
    }
</script>

<style scoped>

</style>